<template>
	<div class="container">
	       <h4>Nuevo video</h4>
	       <div class="form-group" style="text-align: center;">
	        <input type="text" 
	            placeholder="Nombre del video" 
	            class="form-control"
	            v-model="nuevoVideo"
	            v-on:keyup.enter="agregarVideo">
	            <br>
	        <input type="text" 
	        placeholder="URL del video" 
	        class="form-control"
	        v-model="nuevaURL">
	        <br>
	        <button type="button" 
	            class="btn btn-primary btn-lg glyphicon glyphicon-floppy-save"
	            v-on:click="agregarVideo"> Guardar 
	        </button>
	      </div>  
    </div>
</template>
<script>
	export default{
		data(){
			return{
				nuevoVideo : '',
				nuevaURL : ''
			}
		},
		props:['videos'],
		methods:{
			agregarVideo : function(){
				var name = this.nuevoVideo.trim()
				var dir = (this.nuevaURL.trim()).substring(32);
				if(name){
					dir = "http://www.youtube.com/embed/"
							+ dir
							+ "?autohide=1&showinfo=0&rel=0";
					
					this.videos.push({
						nombre : name,
						url : dir,
						visible : true
					})
				}

				console.log(this.videos[this.videos.length-1]);

				this.nuevoVideo = '';
				this.nuevaURL = '';

				this.$http.post('videos-adn.json',{
					nombre : name,
					url : dir,
					visible : true
				}).then(respuesta => {
						this.videos[this.videos.length-1].id = respuesta.body.name; 
					});

				
				//console.log(this.videos[this.videos.length-1]);




			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/NuevoVideoComponent.vue